import React from 'react';
import { useUniversity } from '../contexts/UniversityContext';
import { Card } from './layout/Card';

export function GPATable() {
  const { selectedUniversity } = useUniversity();

  // Group grades by category
  const groupedGrades = selectedUniversity.gradeScale.reduce((acc, grade) => {
    const category = grade.category || 'Regular Grades';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(grade);
    return acc;
  }, {} as Record<string, typeof selectedUniversity.gradeScale>);

  return (
    <Card>
      <h2 className="text-lg font-semibold text-gray-800 mb-4">
        {selectedUniversity.name} GPA Scale
      </h2>
      
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-4 py-2 text-left">Grade</th>
              <th className="px-4 py-2 text-left">Points</th>
              <th className="px-4 py-2 text-left">Range</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(groupedGrades).map(([category, grades]) => (
              <React.Fragment key={category}>
                <tr className="bg-gray-50">
                  <td colSpan={3} className="px-4 py-2 font-medium">{category}</td>
                </tr>
                {grades.map((grade) => (
                  <tr key={grade.grade} className="border-t">
                    <td className="px-4 py-2">{grade.grade}</td>
                    <td className="px-4 py-2">{grade.points.toFixed(2)}</td>
                    <td className="px-4 py-2">
                      {grade.minScore !== undefined && grade.maxScore !== undefined
                        ? `${grade.minScore}-${grade.maxScore}%`
                        : grade.description || '-'}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}